import IntegritasLogo from '../../assets/logos/IntegritasLogo.svg';
import { INTEGRITAS_BASE_URL } from '../../config/constants';

interface IntegritasBtnProps {
  className?: string;
}

const IntegritasBtn = ({ className = 'mb-4 sm:mb-0' }: IntegritasBtnProps) => {
  return (
    <a
      href={`${INTEGRITAS_BASE_URL}`}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      <img
        src={IntegritasLogo}
        alt="Integritas Logo"
        className="w-[165px] h-[42px] md:w-[200px] md:h-[50px]"
      />
    </a>
  );
};

export default IntegritasBtn;
